import { NumberRange } from 'scichart/Core/NumberRange';
import { dateTickDeltas } from './EDateTickDelta';
import { TDateTzConverterFn } from './timezones';

const toYear = (unixTimestamp: number): string => {
    // We add 2 days (2 * 86400) offset to show correctly for a leap year and different timezones
    const date = new Date((unixTimestamp + 86400) * 1000);
    const year = date.getUTCFullYear();
    if (isNaN(year)) return '';
    return year.toString(10);
};
const toMonth = (unixTimestamp: number, locale = 'en'): string => {
    const date = new Date(unixTimestamp * 1000);
    return date.toLocaleDateString(locale, {
        timeZone: 'utc',
        month: 'short',
        year: '2-digit'
    });
};
const toDay = (unixTimestamp: number, locale = 'en'): string => {
    const date = new Date(unixTimestamp * 1000);
    return date.toLocaleDateString(locale, {
        timeZone: 'utc',
        month: 'short',
        day: '2-digit'
    });
};
/**
 * Example of custom formatting for different locales
 * @param unixTimestamp
 * @param locale
 */

const toHourMinute = (unixTimestamp: number): string => {
    const date = new Date(unixTimestamp * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    if (isNaN(hours) || isNaN(minutes)) return '';
    const hoursString = hours <= 9 ? `0${hours}` : hours.toString(10);
    const minutesString = minutes <= 9 ? `0${minutes}` : minutes.toString(10);
    return `${hoursString}:${minutesString}`;
};
const toSecond = (unixTimestamp: number): string => {
    const date = new Date(unixTimestamp * 1000);
    const seconds = date.getUTCSeconds();
    if (isNaN(seconds)) return '';
    const secondsString = seconds <= 9 ? `0${seconds}` : seconds.toString(10);
    return `${secondsString}s`;
};
const isNewMonth = (unixTimestamp: number, delta: number): boolean => {
    const prevDate = new Date((unixTimestamp - delta) * 1000);
    const curDate = new Date(unixTimestamp * 1000);
    return prevDate.getUTCMonth() !== curDate.getUTCMonth();
};
const toFullDateTime = (unixTimestamp: number, dateTzConverter: TDateTzConverterFn, locale = 'en', includeSeconds = true): string => {
    const date = new Date(dateTzConverter(unixTimestamp * 1000));
    var dateString = date.toLocaleDateString(locale, { timeZone: 'utc', month: 'short', day: '2-digit', year: '2-digit'});
    var timeString = includeSeconds ? date.toLocaleTimeString(locale, { timeZone: 'utc', hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit'}) : date.toLocaleTimeString(locale, { timeZone: 'utc', hourCycle: 'h23', hour: '2-digit', minute: '2-digit'});
    
    return `${dateString} @ ${timeString}`;
};

const toFullDateOnly = (unixTimestamp: number, dateTzConverter: TDateTzConverterFn, locale = 'en'): string => {
    const date = new Date(dateTzConverter(unixTimestamp * 1000));
    var dateString = date.toLocaleDateString(locale, { timeZone: 'utc', month: 'short', day: '2-digit', year: '2-digit'});
    
    return `${dateString}`;
};

const getDeltaFromRange = (min: number, max: number, minorsPerMajor: number, maxTicks: number) => {
    const diff = max - min;
    let ticks = diff;
    let i = 1;
    let delta = 1;
    while (ticks > 10 && i < dateTickDeltas.length) {
        delta = dateTickDeltas[i];
        ticks = Math.floor(diff / delta);
        i++;
    }
    return new NumberRange(delta / minorsPerMajor, delta);
};
export const axisLabelDateFormatter = {
    toYear,
    toMonth,
    toDay,
    toHourMinute,
    toSecond,
    isNewMonth,
    toFullDateTime,
    getDeltaFromRange,
    toFullDateOnly
};